import { render, staticRenderFns } from "./CreateAttributeForm.vue?vue&type=template&id=5849696a&scoped=true"
import script from "./CreateAttributeForm.vue?vue&type=script&lang=js"
export * from "./CreateAttributeForm.vue?vue&type=script&lang=js"
import style0 from "./CreateAttributeForm.vue?vue&type=style&index=0&id=5849696a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5849696a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5849696a')) {
      api.createRecord('5849696a', component.options)
    } else {
      api.reload('5849696a', component.options)
    }
    module.hot.accept("./CreateAttributeForm.vue?vue&type=template&id=5849696a&scoped=true", function () {
      api.rerender('5849696a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/attributes/modules/use_cases/components/CreateAttributeForm.vue"
export default component.exports